import { render, staticRenderFns } from "./IconPaper.vue?vue&type=template&id=d869e0c6&"
import script from "./IconPaper.vue?vue&type=script&lang=js&"
export * from "./IconPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports